<header class="flex header">
  <h2>Roll Details</h2>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>

<section class="content">
  <p-card>
    <div class="col">
      <div class="form-box">
        <label>Roll ID</label>
        <input type="text" pInputText class="w-full" [disabled]="true" [value]="roll?.id" />
      </div>
      <div class="form-box">
        <label>Roll Number</label>
        <input type="text" pInputText class="w-full" [disabled]="true" [value]="roll?.number" />
      </div>
      <div class="form-box">
        <label>Roll Status</label>
        <input type="text" pInputText class="w-full" [disabled]="true" [value]="getStatus(roll?.status!)" />
      </div>
      <div class="form-box">
        <label>Roll KO</label>
        <input type="text" pInputText class="w-full" [disabled]="true" [value]="roll?.knittingOrderNumber" />
      </div>
      <div class="form-box">
        <label>Roll Yarn Est. Weight</label>
        <input type="text" pInputText class="w-full" [disabled]="true" />
      </div>
      <div class="form-box">
        <label>Roll Yarn Plan. Weight</label>
        <input type="text" pInputText class="w-full" [disabled]="true" [value]="roll?.plannedWeight" />
      </div>
      <div class="form-box">
        <label>Time Stamps</label>
        <p-datepicker fluid class="w-full" [disabled]="true" />
      </div>
    </div>
  </p-card>
</section>

<footer>
  <p-button class="w-full" [label]="'Common_Exit' | translateWF: 'Exit'" variant="outlined" (click)="onClose()" />
</footer>
